// extracted by mini-css-extract-plugin
export default {"totalVendors":"totalVendors__YjA3O"};